import { IGuest } from "@/@types/admin/guest/user";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { Component, Vue } from "vue-property-decorator";
import { calculateAge } from "@/services/dateTime/ages";
import { auth, multimedia } from "@/config/host.config";
import { calculateAge as getAge } from "@/services/dateTime/ages";
import { getBirthday } from "@/services/dateTime/date-time-fofmat";
import { IRoom } from "@/@types/hotel/room";

@Component({})
export default class Guests extends Vue {
  guestList: Array<IGuest> = [];
  virtualRooms: Array<IVirtualRooma> = [];

  get guests(): Array<IGuest> {
    const wiev = (this as any).registrated;
    let guests: Array<IGuest> = [];

    if (wiev == "populated") guests = this.registeredGuests;
    else if (wiev == "new") guests = this.newGuests;
    else guests = this.byCruise;

    if (this.$data.search) {
      const arr = guests;
      // surname
      guests = arr.filter((item: IGuest) => {
        if (item.personal_data)
          return (
            item.personal_data.surname
              .toLowerCase()
              .indexOf(this.$data.search.toLowerCase()) > -1
          );
      });

      // room.number
      if (!guests.length) {
        guests = arr.filter((item: IGuest) => {
          console.log(item.stay_data);
          if (
            item.stay_data &&
            item.stay_data.room &&
            item.stay_data.room.number
          )
            return item.stay_data.room.number.indexOf(this.$data.search) > -1;
        });
      }
      console.log(guests);
      // order_number
      if (!guests.length)
        guests = arr.filter((item: IGuest) => {
          if (item.stay_data && item.stay_data.order_number)
            return item.stay_data.order_number.indexOf(this.$data.search) > -1;
        });

      // document number
      if (!guests.length)
        guests = arr.filter((item: IGuest) => {
          if (item.personal_data && item.personal_data.documents)
            return (
              item.personal_data.documents.number.indexOf(this.$data.search) >
              -1
            );
        });
    }

    if (this.$data.children) {
      guests = guests.filter((guest) => {
        if (guest.personal_data && guest.personal_data.birthday) {
          const age = calculateAge(guest.personal_data.birthday);
          const years = this.$data.children.split("-");
          if (years.length === 1 && age == parseInt(years[0])) return guest;
          if (age >= parseInt(years[0]) && age < parseInt(years[1]))
            return guest;
        }
      });
    }
    if (this.$data.pensioners) {
      guests = guests.filter((guest) => {
        if (guest.personal_data && guest.personal_data.birthday) {
          const age = calculateAge(guest.personal_data.birthday);
          const men = 60;
          const women = 55;
          if (guest.personal_data.gender) {
            if (guest.personal_data.gender == 1) if (age >= men) return guest;
            if (guest.personal_data.gender == 2) if (age >= women) return guest;
          }
        }
      });
    }
    if (this.$data.birthday) {
      guests = guests.filter((guest) => {
        if (
          guest.personal_data &&
          guest.personal_data.birthday &&
          guest.stay_data?.arrival &&
          guest.stay_data?.departure
        ) {
          // Создаем дату рождения с текущим годом круиза
          const arrival = new Date(guest.stay_data.arrival);
          const departure = new Date(guest.stay_data.departure);
          const birthdayThisYear = new Date(guest.personal_data.birthday);
          birthdayThisYear.setFullYear(arrival.getFullYear());

          // Приводим все даты к началу дня для корректного сравнения только дат (без времени)
          const arrivalDateOnly = new Date(arrival.setHours(0, 0, 0, 0));
          const departureDateOnly = new Date(departure.setHours(0, 0, 0, 0));
          const birthdayDateOnly = new Date(
            birthdayThisYear.setHours(0, 0, 0, 0)
          );

          if (this.$data.birthday == "today") {
            const today = new Date();

            if (
              birthdayThisYear.getDate() == today.getDate() &&
              birthdayThisYear.getMonth() == today.getMonth()
            )
              return guest;
          } else if (
            birthdayDateOnly >= arrivalDateOnly &&
            birthdayDateOnly <= departureDateOnly
          )
            return guest;
        }
      });
    }
    if (this.$data.gender) {
      guests = guests.filter((guest) => {
        if (guest.personal_data?.gender == this.$data.gender) return guest;
      });
    }
    if (this.$data.doc_type) {
      guests = guests.filter((guest) => {
        if (guest.personal_data?.documents?.doctype == this.$data.doc_type)
          return guest;
      });
    }
    if (this.$data.citizenship) {
      guests = guests.filter((guest) => {
        if (guest.personal_data?.nationality == this.$data.citizenship)
          return guest;
      });
    }
    if (this.$data.room_type) {
      const rooms: string[] = [];
      this.$data.rooms.forEach((r: IRoom) => {
        if (r.type == this.$data.room_type) rooms.push(r._id);
      });

      guests = guests.filter((guest) => {
        if (guest.stay_data?.room && rooms.includes(guest.stay_data.room.id))
          return guest;
      });
    }
    if (this.$data.room_level) {
      const rooms: string[] = [];
      this.$data.rooms.forEach((r: IRoom) => {
        if (r.level == this.$data.room_level) rooms.push(r._id);
      });
      guests = guests.filter((guest) => {
        if (guest.stay_data?.room && rooms.includes(guest.stay_data.room.id))
          return guest;
      });
    }

    return guests;
  }

  get newGuests(): Array<IGuest> {
    return this.byCruise.filter((guest) => {
      const id = guest._id ? guest._id : "";
      if (!id) return guest;
      const vrooma = this.virtualRooms.find((vr) => vr.guests.includes(id));
      if (!vrooma || !vrooma.room) return guest;
    });
  }

  get registeredGuests(): Array<IGuest> {
    return this.byCruise.filter((guest) => {
      const id = guest._id ? guest._id : "";
      const vrooma = this.virtualRooms.find((vr) => vr.guests.includes(id));
      if (vrooma) return guest;
    });
  }

  get sort(): { name: string; data: string } | null {
    if ((this as any).children)
      return { name: "children", data: (this as any).children };
    if ((this as any).pensioners) return { name: "pensioners", data: "" };
    if ((this as any).birthday)
      return { name: "birthday", data: (this as any).birthday };
    if ((this as any).cruise_code)
      return { name: "cruise_code", data: (this as any).cruise_code };
    if ((this as any).gender)
      return { name: "gender", data: (this as any).gender };
    if ((this as any).doc_type)
      return { name: "doc_type", data: (this as any).doc_type };
    if ((this as any).citizenship)
      return { name: "citizenship", data: (this as any).citizenship };
    if ((this as any).room_type)
      return { name: "room_type", data: (this as any).room_type };
    if ((this as any).room_level)
      return { name: "room_level", data: (this as any).room_level };
    if ((this as any).registrated && (this as any).registrated !== "all")
      return { name: "registered", data: (this as any).registrated };
    return null;
  }

  get byCruise(): Array<IGuest> {
    if (!this.$data.cruise_code) return this.guestList;
    return this.guestList.filter((guest) => {
      const cruise_code = guest.stay_data ? guest.stay_data.cruise_code : "";
      if (cruise_code == this.$data.cruise_code) return guest;
    });
  }

  get cruiseCodes(): Array<string> {
    const codes: Array<string> = [];
    this.guestList.forEach((el) => {
      if (el.stay_data?.cruise_code)
        if (!codes.includes(el.stay_data.cruise_code))
          codes.push(el.stay_data.cruise_code);
    });
    return codes;
  }

  get citizenships(): Array<string> {
    const guests_sitizenship: string[] = [];
    this.guestList.forEach((g) => {
      const nat = g.personal_data.nationality;
      if (nat && !guests_sitizenship.includes(nat))
        guests_sitizenship.push(nat);
    });
    return guests_sitizenship;
  }

  async exportPhones(): Promise<void> {
    const uri = auth.guest.export_phones;
    try {
      const response = await this.$axios.get(uri, { responseType: "blob" });
      if (response.status === 200) {
        const contentDisposition = response.headers["content-disposition"];
        let filename = "export_phones.zip";

        // Если сервер отправляет имя файла в заголовках
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async downloadExcel(): Promise<void> {
    const uri = multimedia.export.excel;
    const excel: Array<IExcel> = [];
    if (!this.$options.computed || !this.$options.computed.guests) return;
    this.guests.forEach((el: IGuest, i: number) => {
      const guest: IExcel = {};
      guest.i = { name: "№", value: String(i + 1) };
      if (this.$data.show_room)
        guest.room = {
          name: String(this.$i18n.tc("change.room-hc", 1)),
          value: el.stay_data?.room?.number || "",
        };
      if (el.personal_data) {
        const name = `${el.personal_data.surname} ${el.personal_data.first_name} ${el.personal_data.second_name}`;
        guest.name = {
          name: String(this.$i18n.t("Guests.List.name")),
          value: name,
        };
      }
      if (this.$data.show_age && el.personal_data?.birthday) {
        const age = getAge(el.personal_data.birthday);
        guest.age = {
          name: String(this.$i18n.t("Guests.List.sorts.children.label")),
          value: String(age),
        };
      }
      if (this.$data.show_phone_number) {
        const st_ph = el.additional_data?.phone_number || "";
        const wifi_hp = el.additional_data?.internet_access.length
          ? el.additional_data?.internet_access[0].phone
          : "";
        guest.phone_number = {
          name: String(this.$i18n.t("Guests.Add.form.phoneNumber.label")),
          value: st_ph ? st_ph : wifi_hp,
        };
      }
      if (this.$data.show_email) {
        guest.email = {
          name: "Emain",
          value: el.additional_data?.email || "",
        };
      }
      if (this.$data.show_document) {
        guest.document = {
          name: String(this.$i18n.t("Guests.Add.form.document.name")),
          value: el.personal_data?.documents?.number || "",
        };
      }
      if (this.$data.show_birthday && el.personal_data.birthday) {
        guest.birthday = {
          name: String(this.$i18n.t("Guests.List.birthday")),
          value: getBirthday(el.personal_data.birthday) || "",
        };
      }
      if (this.$data.show_ad && el.stay_data) {
        if (el.stay_data.arrival)
          guest.arrival = {
            name: String(this.$i18n.t("Guests.List.ar")),
            value: getBirthday(el.stay_data.arrival) || "",
          };
        if (el.stay_data.departure)
          guest.departure = {
            name: String(this.$i18n.t("Guests.List.de")),
            value: getBirthday(el.stay_data.departure) || "",
          };
      }
      if (this.$data.show_order_number) {
        guest.birthday = {
          name: String(
            this.$i18n.t("Guests.Add.form.orderNumber.label", {
              order_number: this.$i18n.t("change.order_number"),
            })
          ),
          value: el.stay_data?.order_number || "",
        };
      }
      if (this.$data.show_gender) {
        const gender = el.personal_data
          ? this.$i18n.tc(`main.gender.${el.personal_data.gender}`, 2)
          : "";
        guest.gender = {
          name: String(this.$i18n.t("main.gender.label")),
          value: gender,
        };
      }
      if (this.$data.show_table) {
        guest.table = {
          name: String(this.$i18n.t("Guests.Add.form.table.label")),
          value: "",
        };
      }
      if (this.$data.show_comment) {
        guest.comment = {
          name: String(this.$i18n.t("Guests.Add.form.comment.label")),
          value: el.comment,
        };
      }

      excel.push(guest);
    });

    try {
      const response = await this.$axios.post(uri, excel, {
        responseType: "blob",
      });
      if (response.status === 200) {
        const contentDisposition = response.headers["content-disposition"];
        let filename = "report.xlsx";

        // Если сервер отправляет имя файла в заголовках
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
